// Direct Bouwmaterialen Shopify theme JS
document.addEventListener('click', (e) => {
  const t = e.target.closest('[data-qty]');
  if (t) {
    const input = t.parentElement.querySelector('input');
    let v = parseInt(input.value || '1', 10);
    v += parseInt(t.dataset.qty, 10);
    input.value = Math.max(1, v);
  }
});

// Product gallery thumbs
document.querySelectorAll('[data-gallery-thumb]').forEach(btn => {
  btn.addEventListener('click', () => {
    const main = document.querySelector('[data-gallery-main]');
    if (main) main.src = btn.dataset.src;
  });
});
